import axios from "axios";
const instance = axios.create({
    baseURL: '', // Đảm bảo baseURL là URL chính xác của API
});


export default instance 
